(function ($) {
	'use strict';


	$('.jsFilter').each(function () {
		var $this = $(this),
			filterYear  = $this.find('.jsFilterYear'),
			filterMonth = $this.find('.jsFilterMonth');

		if ( !filterYear.val() ) {
			filterMonth.attr('disabled', 'true');
		}


		$this.find('select').on('change', function (event) {
			var chapter = $this.hasClass('chapter');
			if( !chapter ){
				insertFilterParam( $(this).data('type'), $(this).val() );
			} else{
				// if chapter, redirect to post from val
				document.location = $(this).val();
			}
		});
	});


	$('.filterSelect').chosen({
		disable_search: true
	});
})(jQuery);
